import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { IProductContract } from 'src/app/core/interfaces/shared/bundle/IProductContract';

@Component({
  selector: 'app-product-contract-form',
  templateUrl: './product-contract-form.component.html',
  styleUrls: ['./product-contract-form.component.scss'],
})
export class ProductContractFormComponent implements OnInit {
  @Input('data') productFormContract: IProductContract = {
    marca: '',
    modelo: '',
    numSerie: '',
  };

  @Output() emitFormProductData = new EventEmitter<IProductContract>();
  @Output() isCompleted = new EventEmitter<boolean>();

  productForm = new FormGroup({
    marca: new FormControl(this.productFormContract.marca, [
      Validators.required,
    ]),
    modelo: new FormControl(this.productFormContract.modelo, [
      Validators.required,
    ]),
    numSerie: new FormControl(this.productFormContract.numSerie, []),
  });

  get marca() {
    return this.productForm.get('marca');
  }

  get modelo() {
    return this.productForm.get('modelo');
  }

  get numSerie() {
    return this.productForm.get('numSerie');
  }

  keyTranslate: string = 'clientContracts.forms.productContractForm.label';

  constructor() {}

  ngOnInit(): void {
    this.saveDataProductForm();
    this.productForm.patchValue(this.productFormContract, {
      onlySelf: true,
      emitEvent: false,
    });
  }

  saveDataProductForm() {
    this.productForm.valueChanges
      .pipe(debounceTime(500))
      .subscribe((formData) => {
        this.emitFormProductData.emit(null);
        if (this.productForm.valid) {
          this.emitFormProductData.emit(formData);
          this.isCompleted.emit(true);
        } else {
          this.isCompleted.emit(false);
        }
      });
  }
}
